import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";

/**
 * bn-field is the labeled form-row wrapper: a label (with an optional required
 * asterisk), a slotted control (bn-input, a native input, a select, …), and an
 * optional hint or error message below. It carries no input state itself.
 *
 *   <bn-field label="Workspace name" ?required=${true} error=${err}>
 *     <bn-input .value=${name} @input=${…}></bn-input>
 *   </bn-field>
 */
@customElement("bn-field")
export class BnField extends LitElement {
  @property() label = "";
  @property() hint = "";
  @property() error = "";
  @property({ type: Boolean }) required = false;

  static override styles = css`
    :host {
      display: block;
      margin-bottom: var(--bino-space-md);
    }
    label {
      display: block;
      font-family: var(--bino-font-sans);
      font-size: var(--bino-font-size-base);
      font-weight: 500;
      color: var(--bino-text-muted);
      margin-bottom: 0.375rem;
    }
    .req {
      color: var(--bino-error);
      margin-left: 2px;
    }
    .hint {
      font-size: var(--bino-font-size-sm);
      color: var(--bino-text-secondary);
      margin-top: 0.375rem;
    }
    .error {
      font-size: var(--bino-font-size-sm);
      color: var(--bino-error);
      margin-top: 0.375rem;
    }
  `;

  override render() {
    return html`
      ${this.label
        ? html`<label
            >${this.label}${this.required ? html`<span class="req" aria-hidden="true">*</span>` : ""}</label
          >`
        : ""}
      <slot></slot>
      ${this.error
        ? html`<div class="error" role="alert">${this.error}</div>`
        : this.hint
          ? html`<div class="hint">${this.hint}</div>`
          : ""}
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bn-field": BnField;
  }
}
